// Plugin
import Swiper from 'swiper/bundle';
import { Navbar, Modal } from 'bootstrap';
import WOW from 'wow.js';

new WOW().init();

// Navbar
window.addEventListener('scroll', () => {
    let nav = document.querySelector('.navbar');
    if(window.scrollY > 0){
        nav.classList.add('top');
    }else{
        nav.classList.remove('top');
    }
})

let navDropdown = document.querySelector('.nav-dropdown');
navDropdown.addEventListener('click', () => {
    navDropdown.classList.toggle('show');
})
document.querySelector('body').addEventListener('click', (e) => {
    if(!e.target.closest('.nav-dropdown')){
        navDropdown.classList.remove('show');
    }
});
let btnToggleNav = document.querySelector('.btn-toggle-nav');
let allNavLinks = document.querySelectorAll('.nav-link');
allNavLinks.forEach(navLink => {
    navLink.addEventListener('click', (e) => {
        // Close Nav
        if(window.innerWidth < 1200){
            btnToggleNav.click();
        }
        // Scroll to Section
        let id = navLink.querySelector('a').getAttribute('href');
        e.preventDefault()
        let timeout = window.innerWidth < 1200 ? 500 : 0;
        setTimeout(() => {
            window.scrollTo({
                top: document.querySelector(id).offsetTop - document.querySelector('.navbar').offsetHeight,
                behavior: 'smooth'
            })
        }, timeout)

    })
})

// ViewportHeight
const updateViewportHeight = () => {
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
};
updateViewportHeight();

// Page Hash
let hash = window.location.hash;
if(hash){
    setTimeout(() => {
        window.scrollTo({
            top: document.querySelector(hash).offsetTop - document.querySelector('.navbar').offsetHeight,
            behavior: 'smooth'
        })
    }, 1000);
}

//Page Texture
window.addEventListener('load', () => {
    setTimeout(() => {
        document.querySelector(':root').style.setProperty('--overlay-texture-mode', 'color-burn')
        document.querySelector(':root').style.setProperty('--overlay-texture-opacity', '0.5')
    }, 1)
})

// Swiper
let headerSwiper = new Swiper(".header-swiper", {
    autoplay: {
        delay: 3000
    },
    effect: "cards",
    cardsEffect: {
        perSlideOffset: 20,
        perSlideRotate: 0,
        rotate: false
    },
    speed: 500,
    rewind: true,
    pagination: {
    el: ".header-swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: '.header-swiper-right',
        prevEl: '.header-swiper-left',
    },
    grabCursor: false,
    allowTouchMove: false
});

let bookSwiper = new Swiper(".book-swiper", {
    autoplay: {
        delay: 5000
    },
    speed: 1000,
    scrollbar: {
        el: ".book-scrollbar"
    },
    slidesPerView: 4.3,
    spaceBetween: 12,
    freeMode: true,
    breakpoints: {
        768: {
            slidesPerView: 6.3,
            spaceBetween: 20,
        },
        540: {
            slidesPerView: 5.3,
            spaceBetween: 15,
        }
    }
});

// Dishes Changer
const allBooks = document.querySelectorAll('.book');
const allBookSlide = document.querySelectorAll('.book-slide');
const mirrorImage = document.querySelector('.mirror-image');
const dishIntroTitle = document.querySelector('.dish-intro').querySelector('h4');
const dishIntroText = document.querySelector('.dish-intro').querySelector('p');
allBooks.forEach(book => {
    book.addEventListener('click', () => {
        mirrorImage.classList.add('changing')
        setTimeout(() => {
            // data change
            mirrorImage.querySelector('img').setAttribute('src', book.querySelector('.book-image').querySelector('img').getAttribute('src'));
            dishIntroTitle.innerText = book.getAttribute('data-name')
            dishIntroText.innerHTML = book.getAttribute('data-description')
            mirrorImage.classList.remove('changing')
        }, 500)
    })
})
allBookSlide.forEach(slide => {
    slide.addEventListener('click', () => {
        mirrorImage.classList.add('changing')
        setTimeout(() => {
            // data change
            mirrorImage.querySelector('img').setAttribute('src', slide.querySelector('.book-image').querySelector('img').getAttribute('src'));
            dishIntroTitle.innerText = slide.getAttribute('data-name')
            dishIntroText.innerHTML = slide.getAttribute('data-description')
            mirrorImage.classList.remove('changing')
        }, 500)
    })
})

let nextBookGroup = 2
let btnDishesChanger = document.querySelector('#dishesChanger');

if(document.querySelectorAll('[data-book="2"]').length < 8){
    btnDishesChanger.remove();
}
btnDishesChanger.addEventListener('click', () => {
    btnDishesChanger.style.pointerEvents = 'none';
    let allBookGroup = document.querySelectorAll(`[data-book]`);
    allBookGroup.forEach(book => {
        book.style.opacity = 0;
        book.style.pointerEvents = 'none';
    })
    switch(nextBookGroup){
        case 1:
            switchBookGroup(1)
            nextBookGroup = document.querySelectorAll('[data-book="2"]').length == 8 ? 2 : 1
            console.log(nextBookGroup)
            break;
        case 2:
            switchBookGroup(2)
            nextBookGroup = document.querySelectorAll('[data-book="3"]').length == 8 ? 3 : 1
            console.log(nextBookGroup)
            break;
        case 3:
            switchBookGroup(3)
            nextBookGroup = 1
            break;
    }
    setTimeout(() => {
        btnDishesChanger.style.pointerEvents = 'auto';
    }, 1000)
})
switchBookGroup(1);

function switchBookGroup(activeIndex){
    let allBookGroup = document.querySelectorAll(`[data-book]`);
    allBookGroup.forEach(book => {
        book.style.opacity = 0;
        book.style.pointerEvents = 'none';
    })
    let activeBookGroup = document.querySelectorAll(`[data-book="${activeIndex}"]`);
    setTimeout(() => {
        activeBookGroup.forEach(book => {
            book.style.opacity = 1;
            book.style.pointerEvents = 'auto';
        })
    }, 600)
}

// Location Tabs
let locationTabs = document.querySelector('.locations-card').querySelectorAll('.tab');
let locationPhotos = document.querySelector('.locations-photo').querySelectorAll('img');
let locationInfos = document.querySelector('.locations-card').querySelectorAll('.card-info');
locationTabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
        locationTabs.forEach(tab => {
            tab.classList.remove('active');
        })
        tab.classList.add('active');
        
        locationPhotos.forEach(photo => {
            photo.classList.remove('active');
        })
        setTimeout(()=>{locationPhotos[index].classList.add('active');}, 500)

        locationInfos.forEach(info => {
            info.classList.remove('active');
        })
        locationInfos[index].classList.add('active');
    })
})

// News Modal
document.addEventListener('DOMContentLoaded', () => {
    let newsModal = document.querySelector('#newsModal');
    if(newsModal) {
        window.scrollTo(0, 0)
        $('#newsModal').modal('show');
    }
})